import {_} from 'lodash';
import {global} from "../../../../../appContext";
import {ObjectTypeId, SNACKBAR_DURATION_SHORT} from "../../../../../constants";
import {nsRule} from "../nsRule";
import {IParams, viewModel as ArrayArgumentViewModel} from './array'
import {AvailableData} from "../AvailableData";
import entrytypeHtml from './entrytype.html?raw';

export let template = entrytypeHtml;

interface IEntryTypeArgumentParams extends IParams {
    availableData: AvailableData
}

export class viewModel extends ArrayArgumentViewModel {
    private availableData: AvailableData;

    constructor(params: IEntryTypeArgumentParams) {
        super(params);
        this.availableData = params.availableData

        this.kosub.subscribe(this.tag, val => {
            if (!val) {
                return;
            }
            const arr = _(nsRule.parseArrayArgument(val.trim())).uniq().value();
            const newArr = _([...this.tags(), ...arr]).uniq().value()
            this.tags(newArr)
            if (arr.length) {
                global.snackbarData({message: `added subject|s:${arr.join(', ')}`, duration: SNACKBAR_DURATION_SHORT})
            }
            this.tag("")
        })
    }

    private availableEntryTypes() {
        return _.sortBy(this.availableData.syncfields[ObjectTypeId.Event]?.filter(o => !this.tags().includes(o.name)) ?? [], 'name')
    }
}